import { soyshareApi } from '../../../../../services/api'

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getAttachmentsByForm: build.query({
      query: ({ attachmentId }) => ({ url: `/attachements/${attachmentId}` }),
      providesTags: ['attachments-by-form']
    }),

    uploadAttachment: build.mutation({
      query: ({ payload }) => ({
        url: `/attachements`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        body: payload
      }),
      invalidatesTags: ['attachments-by-form']
    }),

    removeAttachment: build.mutation({
      query: ({ attachmentId }) => ({
        url: `/attachements/${attachmentId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['attachments-by-form']
    })
  })
})

export const { useGetAttachmentsByFormQuery, useUploadAttachmentMutation, useRemoveAttachmentMutation } = api
